// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: 'Wybierz',
    titleLinkTooltip: 'Przejdź do strony',
    collapseCardTooltip: 'Zwiń kartę',
    expandCardTooltip: 'Rozwiń kartę'
  },
  CardList: {
    loadMore: 'Załaduj więcej',
    notFound: 'Nie znaleziono żadnych elementów.',
    toolbarSelect: 'Wybierz',
    viewCards: 'Karty',
    viewTiles: 'Kafelki',
    viewList: 'Lista',
    toolbarView: 'Widok'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: 'Wyjdź',
    cancel: 'Wróć',
    content: 'Czy na pewno chcesz zamknąć i opuścić to okno? Wszelkie zmiany w danych, które dokonałeś, nie zostaną zapisane.'
  },
  Cuttable: {
    showMore: 'Pokaż więcej',
    showLess: 'Pokaż mniej'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'Anuluj'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'Anuluj'
  },
  Dropdown: {
    close: 'Zamknij'
  },
  Form: {
    submitButton: 'Zapisz',
    applyButton: 'Zastosuj',
    cancelButton: 'Anuluj'
  },
  FormField: {
    clear: 'Wyczyść',
    remove: 'Usuń',
    addMore: 'Dodaj jeszcze jeden',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'Aby ulepszyć Twoje hasło:',
    passwordTooShort: 'Wydłuż swoje hasło.',
    lettersLowerCase: 'Wykorzystaj co najmniej jedną małą literę.',
    lettersUpperCase: 'Wykorzystaj co najmniej jedną dużą literę.',
    numbers1: 'Wykorzystaj co najmniej jedną cyfrę.',
    numbers3: 'Wykorzystaj co najmniej trzy cyfry.',
    specialChar1: 'Wykorzystaj co najmniej jeden znak specjalny (np. !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Wykorzystaj co najmniej dwa znaki specjalne (np. !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Wykorzystaj małe i duże litery.',
    comboLettersAndNumbers: 'Wykorzystaj cyfry i litery.',
    comboLettersNumbersSpecial: 'Wykorzystaj cyfry, litery i znaki specjalne.',
    yourPasswordIsStrong: 'Możesz je jeszcze wzmocnić poprzez wydłużenie.',
    passwordStrength: 'Siła hasła to: %%strength%%.',
    strengthVeryStrong: 'BARDZO SILNE',
    strengthStrong: 'SILNE',
    strengthVeryWeak: 'BARDZO SŁABE',
    strengthWeak: 'SŁABE',
    strengthMedium: 'ŚREDNIE',
    hidePassword: 'Ukryj hasło',
    showPassword: 'Pokaż hasło',
    generateButton: 'Wygeneruj',
    copyButtonHint: 'Kopiuj hasło',
    copySuccessToast: 'Hasło zostało skopiowane',
    generateButtonHint: 'Wygeneruj silne hasło'
  },
  InPlaceEdit: {
    cancelButtonHint: 'Odrzuć zmiany',
    editButtonHint: 'Edytuj wartość',
    okButtonHint: 'Zapisz zmiany'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'Wybierz plik...'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: 'Łącznie %%totalRows%% elementów',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: 'Wybrano %%selectedRows%% z %%totalRows%% elementów',
    all: 'Wszystkie',
    allItemsOnPageSelected: 'Wybrano wszystkie elementy na stronie',
    allItemsSelected: 'Wybrano wszystkie elementy',
    selectAllItems: 'Wybierz wszystkie elementy',
    selectAllItemsOnPage: 'Wybierz wszystkie elementy na stronie',
    deselectAll: 'Odznacz',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'Nie można znaleźć żadnych elementów pasujących do filtra',
    emptyTitle: 'Wygląda na to, że nic tu nie ma',
    filteredDescription: 'Doprecyzuj zapytanie lub usuń niektóre kryteria z filtra i spróbuj ponownie.'
  },
  ListOperation: {
    cancelButton: 'Anuluj'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: 'z %%total%%',
    itemsPerPage: 'Elementów na stronę',
    all: 'Wszystkie',
    total: 'Strona %%current%% z %%total%%'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: 'Zamknij',
    cancelButton: 'Anuluj'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'Brak opcji',
    placeholder: 'Wybierz...'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%% z %%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'Zamknij grupę'
  },
  Toast: {
    closeButton: 'Close'
  }
};